import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Link } from 'react-router-dom';
import InputError from '@/container/Ui/Common/InputError';
import { propShape } from '../../../../../helpers/custom-prop-types';
import PlainInput from '../../../../Ui/Common/PlainInput';
const DocumentAssignField = (props) => {
    const { input, meta } = props;
    return (_jsxs("div", Object.assign({ className: 'field' }, { children: [_jsx("div", { children: _jsxs("label", Object.assign({ className: 'pointer' }, { children: [_jsxs("div", Object.assign({ className: 'checkbox_wrapper' }, { children: [_jsx(PlainInput, { className: '', input: input, meta: meta, type: 'checkbox' }), _jsx("i", {})] })), _jsxs("span", { children: [_jsx(Link, Object.assign({ target: '_blank', to: '/terms' }, { children: "\u5229\u7528\u898F\u7D04" })), "\u3001", _jsx(Link, Object.assign({ target: '_blank', to: '/privacy' }, { children: "\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u30DD\u30EA\u30B7\u30FC" })), "\u306B\u540C\u610F\u3057\u307E\u3059"] })] })) }), _jsx(InputError, { meta: meta })] })));
};
DocumentAssignField.propTypes = {
    input: propShape().isRequired,
    meta: propShape().isRequired,
};
export default DocumentAssignField;
